// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__nJxbS","image":"Header_image__2bahS","name":"Header_name__mImWG","info":"Header_info__1L0EC","infoRow":"Header_infoRow__X-rY3"};